import QuickfireBankButtonControl from "quickfire/controls/quickfire-bank-button-control";
import QuickfireBonusBubbleControl from "quickfire/controls/quickfire-bonus-bubble-control";
import QuickfireDiscardFreeGamesControl from "quickfire/controls/quickfire-dicard-free-games-button-control";
import QuickfireResponsibleGamingButtonControl from "quickfire/controls/quickfire-responsible-gaming-button-control";
import ControlList from "slotworks/smart-ui/control-list";
import QuickfireHomeButtonControl from "./quickfire-home-button-control";

export default class QuickfireControlList {

    public static QUICKFIRE_HOME = new ControlList<QuickfireHomeButtonControl>(QuickfireHomeButtonControl, "qf_home");
    public static QUICKFIRE_BANK = new ControlList<QuickfireBankButtonControl>(QuickfireBankButtonControl, "qf_bank");
    public static QUICKFIRE_RESPONSIBLE_GAMING = new ControlList<QuickfireResponsibleGamingButtonControl>(QuickfireResponsibleGamingButtonControl, "qf_responsible_gaming");

    public static QUICKFIRE_BONUS_BUBBLE = new ControlList<QuickfireBonusBubbleControl>(QuickfireBonusBubbleControl, "qf_bonus_bubble");

    public static QUICKFIRE_FREE_GAMES_DISCARD = new ControlList<QuickfireDiscardFreeGamesControl>(QuickfireDiscardFreeGamesControl, "qfg_discard");

    public static init() {
        ControlList.addControlList(QuickfireControlList.QUICKFIRE_HOME);
        ControlList.addControlList(QuickfireControlList.QUICKFIRE_BANK);
        ControlList.addControlList(QuickfireControlList.QUICKFIRE_RESPONSIBLE_GAMING);

        ControlList.addControlList(QuickfireControlList.QUICKFIRE_BONUS_BUBBLE);

        ControlList.addControlList(QuickfireControlList.QUICKFIRE_FREE_GAMES_DISCARD);
    }
}
